import React, { forwardRef } from 'react';
import { HStack as ChakraVStack, StackProps } from '@chakra-ui/react';
interface Props extends StackProps {
  children?: React.ReactNode;
}

export const VStack = forwardRef<HTMLDivElement, Props>(
  (props, ref): JSX.Element => {
    return (
      <ChakraVStack {...props} ref={ref}>
        {props.children}
      </ChakraVStack>
    );
  }
);
